/**
 * Inspetor (desktop): cartão FLUTUANTE sobre a borda direita do mapa, como o
 * do rastreio e previsão — abrir ou fechar não muda o tamanho do mapa nem
 * desloca a imagem (até 08/10/2026 era uma coluna da grade, que empurrava o
 * mapa). Hoje: "Últimos focos". Fechado, vira uma aba fina na borda direita.
 * Ocupa o mesmo lugar do cartão do rastreio: abrir um fecha o outro
 * (`tracking/TrackingFloat`).
 */
import { Flame, PanelRightClose } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { INSPECTOR_WIDTH } from '../map/viewControl';
import { useUiStore } from '../state/ui';
import { RecentFiresInspector } from './RecentFires';
import { IconButton } from './primitives';

/** O inspetor veio aberto da visita anterior: a primeira montagem não rouba o foco. */
let abertoNaCarga = useUiStore.getState().inspectorOpen;

/** Aba fina na borda direita do mapa que abre o inspetor. */
export function InspectorTab() {
  const setInspector = useUiStore((s) => s.setInspector);
  return (
    <button
      type="button"
      onClick={() => setInspector(true)}
      aria-label="Abrir a lista dos últimos focos"
      aria-expanded={false}
      data-inspector-tab
      // Na pilha das abas da direita (App `AbasDaDireita`).
      className="flex h-40 min-h-28 w-7 shrink items-center justify-center rounded-l-xl border border-r-0 border-ink-600/90 bg-ink-900/95 text-ink-100 shadow-lg hover:bg-ink-800 focus-visible:outline-2 focus-visible:outline-mata-400"
    >
      <span className="flex rotate-180 items-center gap-1.5 text-[11px] font-medium whitespace-nowrap [writing-mode:vertical-rl]">
        <Flame className="size-3.5 rotate-90 text-fogo-400" aria-hidden />
        Últimos focos
      </span>
    </button>
  );
}

export function Inspector() {
  const setInspector = useUiStore((s) => s.setInspector);
  const ref = useRef<HTMLElement>(null);
  // Foco vai para o inspetor quando ele abre por ação do usuário (não na carga, aberto pela
  // preferência salva). O cartão monta a cada abertura: a marca da carga é do módulo, não da instância.
  useEffect(() => {
    if (abertoNaCarga) {
      abertoNaCarga = false;
      return;
    }
    ref.current?.focus();
  }, []);
  return (
    <aside
      ref={ref}
      tabIndex={-1}
      // No lugar do cartão do rastreio: à esquerda da coluna do zoom, abaixo da linha de ações.
      className="absolute top-[60px] right-14 z-20 flex h-[calc(100%-120px)] max-h-[720px] min-h-0 flex-col overflow-hidden rounded-xl border border-ink-600/90 bg-ink-900/95 shadow-2xl outline-none"
      style={{ width: INSPECTOR_WIDTH }}
      aria-label="Últimos focos"
      data-testid="recent-fires"
    >
      <header className="flex items-center gap-1.5 border-b border-ink-700/70 py-1.5 pr-1.5 pl-3">
        <Flame className="size-4 shrink-0 text-fogo-400" aria-hidden />
        <h2 className="min-w-0 flex-1 truncate text-sm font-semibold text-ink-100">Últimos focos</h2>
        <IconButton icon={PanelRightClose} label="Recolher últimos focos" size="sm" onClick={() => setInspector(false)} />
      </header>
      <RecentFiresInspector />
    </aside>
  );
}
